import React from "react";

const colorMap = {
  "⬛": "#E0E0E0",    // Light gray to match keyboard "absent"
  "⬛️": "#E0E0E0",   // Variation selector
  "⬜": "#ffffff",    // White for unused / still typing
  "⬜️": "#ffffff",
  "🟨": "#FFCA28",    // Yellow to match keyboard "present"
  "🟩": "#4CAF50",    // Green to match keyboard "correct"
};

const GuessRow = ({ guess = "", result = [] }) => {
  const paddedGuess = guess.padEnd(5).toUpperCase();
  const paddedResult = Array.isArray(result)
    ? [...result, ...Array(5 - result.length).fill("⬜")]
    : Array(5).fill("⬜");

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "6px",
        marginBottom: "6px",
      }}
    >
      {paddedGuess.split("").map((letter, i) => {
        const symbol = paddedResult[i] || "";
        const bg = colorMap[symbol] || "#ffffff";
        const textColor = symbol === "⬜" ? "#000" : "#fff";

        return (
          <div
            key={i}
            style={{
              width: "min(14vw, 64px)",
              height: "min(14vw, 64px)",
              backgroundColor: bg,
              color: textColor,
              fontSize: "clamp(1.2rem, 5vw, 2rem)",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
              textTransform: "uppercase",
              border: "2px solid #d3d6da",
            }}
          >
            {letter}
          </div>
        );
      })}
    </div>
  );
};

export default GuessRow;

